var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-0 text-center font-bold"},[_vm._v("一款类Wordle的猜无机化合物游戏")])
}
var staticRenderFns = []

export { render, staticRenderFns }